<div class="call-initiate-container">
  <h4>Call Support</h4>

  <ng-container *ngIf="(callState$ | async) === 'ringing-out'">
    <div class="calling-state">
      <nb-spinner status="primary"></nb-spinner>
      <p class="calling-text">Calling... please wait</p>
      <button nbButton status="danger" size="small" (click)="callService.endCall()">Cancel</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(callState$ | async) !== 'ringing-out'">
    <ng-container *ngIf="(availableAdmins$ | async) as admins">
      <div *ngIf="admins.length === 0" class="no-agents">
        <nb-icon icon="phone-missed-outline" class="no-agents-icon"></nb-icon>
        <p>No support agents are available right now.</p>
        <p class="text-muted">Please try again later or submit a support ticket.</p>
      </div>

      <div *ngIf="admins.length > 0" class="agents-list">
        <p class="agents-label">Available support agents:</p>
        <div class="agent-item" *ngFor="let admin of admins">
          <div class="agent-info">
            <nb-icon icon="person-outline"></nb-icon>
            <span class="agent-name">{{ admin.name || 'Support Agent' }}</span>
          </div>
          <button
            nbButton
            status="success"
            size="small"
            [disabled]="(callState$ | async) !== 'idle'"
            (click)="requestCall(admin.adminId)">
            <nb-icon icon="phone-outline"></nb-icon>
            Call
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
